var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard-arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.12021 9.28859L12.0002 13.1686L15.8802 9.28859C16.2702 8.89859 16.9002 8.89859 17.2902 9.28859C17.6802 9.67859 17.6802 10.3086 17.2902 10.6986L12.7002 15.2886C12.3102 15.6786 11.6802 15.6786 11.2902 15.2886L6.70021 10.6986C6.31021 10.3086 6.31021 9.67859 6.70021 9.28859C7.09021 8.90859 7.73021 8.89859 8.12021 9.28859Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard-arrow-down.fd4fd876057c0f969676e269041d89ec.svg";
export { ForwardRef as ReactComponent };